import React from "react";
import { IconProps } from "../icon";

export const Expand_05Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 9l6-6m0 0h-6m6 0v6M9 9L3 3m0 0v6m0-6h6m0 12l-6 6m0 0h6m-6 0v-6m12 0l6 6m0 0v-6m0 6h-6"
    />
  </svg>
);
